(function () {
  'use strict';

  var CURRENCY = '£';
  var THRESHOLD = 300;

  function calcMonthly(price) {
    return price < THRESHOLD
      ? (price / 3).toFixed(2)
      : ((price * 0.9) / 10).toFixed(2);
  }

  // Read selling price from the main price status area (not the ATC button copy)
  function getCurrentPrice() {
    var priceArea = document.querySelector('[id^="price-"]:not([id*="sticky"])');
    if (!priceArea) return null;
    var el = priceArea.querySelector('.price-sale') ||
              priceArea.querySelector('.price span') ||
              priceArea.querySelector('.price');
    if (!el) return null;
    var raw = el.textContent.replace(/[^\d.]/g, '');
    var n = parseFloat(raw);
    return isNaN(n) ? null : n;
  }

  // Find the Finance accordion — Liquid stamps it with fjc-finance-accordion class
  function findFinanceTab() {
    return document.querySelector('.fjc-finance-accordion') ||
           (function () {
             var accordions = document.querySelectorAll('.accordion');
             for (var i = 0; i < accordions.length; i++) {
               var heading = accordions[i].querySelector('button p');
               if (heading && /finance/i.test(heading.textContent.trim())) {
                 return accordions[i];
               }
             }
             return null;
           }());
  }

  // Open Finance accordion using the theme's fjc-accordion-open dispatch pattern
  function openFinanceTab(tab) {
    if (!tab) return;
    try {
      var data = Alpine.$data(tab);
      if (data.open) return; // already open
    } catch (e) {}
    // Dispatch the theme's custom open event (picked up by @fjc-accordion-open.window)
    var blockClass = Array.from(tab.classList).find(function (c) {
      return c.indexOf('x-block-collapsible-tab-') === 0;
    });
    var blockId = blockClass ? blockClass.replace('x-block-collapsible-tab-', '') : null;
    if (blockId) {
      tab.dispatchEvent(new CustomEvent('fjc-accordion-open', {
        bubbles: true,
        detail: { id: blockId }
      }));
    } else {
      // Fallback: direct button click
      var btn = tab.querySelector('button');
      if (btn) btn.click();
    }
  }

  // Walk up from the found tab element to the outermost .accordion wrapper.
  // The Liquid structure wraps the inner accordion in an outer
  // collapsible-content-SECTIONID div (also classed .accordion) when metafield
  // data is present. Hiding only the inner element leaves the outer wrapper's
  // margins and border-y visible; we must hide the topmost ancestor.
  function getHideTarget(tab) {
    var el = tab;
    while (el.parentElement && el.parentElement.classList.contains('accordion')) {
      el = el.parentElement;
    }
    return el;
  }

  var lastPrice = null;
  var financeTab = null;

  function update() {
    var price = getCurrentPrice();
    if (price === null) return;
    if (price === lastPrice) return;
    lastPrice = price;

    var monthly = calcMonthly(price);
    var isHighValue = price >= THRESHOLD;

    // Find or create the note element
    var note = document.querySelector('.fjc-pdp-note');
    if (!note) {
      note = document.createElement('div');
      note.className = 'fjc-pdp-note';
      var priceArea = document.querySelector('[id^="price-"]:not([id*="sticky"])');
      if (priceArea) {
        // Place the note above the chains disclaimer when present, so the
        // order is: price → monthly note → chains disclaimer.
        var chains = priceArea.querySelector('.fjc-chains-disclaimer');
        if (chains) {
          chains.parentNode.insertBefore(note, chains);
        } else {
          priceArea.insertAdjacentElement('afterend', note);
        }
      } else {
        return;
      }
    }

    var iconHTML = '';
    if (isHighValue) {
      iconHTML =
        ' <a href="#fjc-finance-tab" class="fjc-pdp-note__icon fjc-finance-icon" aria-label="Finance information">' +
        '<img src="https://cdn.shopify.com/s/files/1/0972/7711/6793/files/info-icon.png?v=1779126142"' +
        ' alt="Finance info" width="16" height="16">' +
        '</a>';
    }

    note.innerHTML =
      'Spread your payments from <strong>' + CURRENCY + monthly + '</strong> per month' + iconHTML;

    // Finance tab: show/hide via both inline style and class.
    // Use getHideTarget so display is set on the outermost wrapper element,
    // which prevents the inner element's border-y and margins showing through.
    if (!financeTab) financeTab = findFinanceTab();
    if (financeTab) {
      if (!financeTab.id) financeTab.id = 'fjc-finance-tab';
      var hideTarget = getHideTarget(financeTab);
      if (isHighValue) {
        hideTarget.style.display = '';
        financeTab.classList.remove('fjc-finance-accordion');
      } else {
        hideTarget.style.display = 'none';
        financeTab.classList.add('fjc-finance-accordion');
      }
    }
  }

  // Info icon click: open Finance accordion and scroll to it
  document.addEventListener('click', function (e) {
    var icon = e.target.closest('.fjc-pdp-note__icon');
    if (!icon) return;
    e.preventDefault();
    var tab = financeTab || findFinanceTab();
    if (!tab) return;
    openFinanceTab(tab);
    setTimeout(function () {
      tab.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }, 60);
  });

  function init() {
    if (window.Shopify && window.Shopify.currency && window.Shopify.currency.active !== 'GBP') return;
    update();

    var priceArea = document.querySelector('[id^="price-"]:not([id*="sticky"])');
    if (!priceArea) return;

    // Watch for in-place price text changes on variant change
    new MutationObserver(update).observe(priceArea, {
      childList: true,
      subtree: true,
      characterData: true
    });

    // Watch for section re-renders on variant change (Eurus dispatches this event)
    var sectionId = priceArea.id.replace('price-', '');
    window.addEventListener('eurus:product-page-variant-select:updated:' + sectionId, function () {
      lastPrice = null;
      setTimeout(update, 50);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

}());
